import { useNavigate } from "react-router-dom"
const CheckoutHeader = ({ heading,step=1 }) => {
    const navigate = useNavigate()
    return (<> 
        <div className="appHeader">
            <div className="left" onClick={(e) => { navigate(-1) }}>
                <button type="button" className="back-button"><i class="ri-arrow-left-line"></i></button>
                <h6 className="mb-0 mt-0 tx-18">{heading}</h6>
            </div>
 
            <div className="right">
                {step}/3
            </div>                                                                                                                      

        </div>
    </>);
}

export default CheckoutHeader